import gql from 'graphql-tag';

export const GET_ADMIN_DASHBOARD_LIST = gql`
  query GetAdminDashboardList($input: ExternalDashboardsAdminInput!) {
    externalDashboards {
      result: externalAdminDashboards(input: $input) {
        error
        success
        list {
          id
          name
          icon
          type
          externalId
          description
          createdDateTime
          updatedDateTime
        }
      }
    }
  }
`;
